<template>
  <div class="home-container">
    <vue-progress-bar />

    <nav class="home-nav">
      <div class="home-nav-content">
        <div class="logo-name">
          <router-link :to="{ path: '/' }">
            <img src="../assets/logo.svg">
          </router-link>
        </div>

        <div class="user">
          <user-options />
        </div>
      </div>
    </nav>
    <transition name="fade">
      <router-view />
    </transition>
    <main-footer v-if="!hasNewLeftNavEnabled" />
  </div>
</template>

<script>
import MainFooter from "@/containers/Core/Footer";
import UserOptions from "@/containers/Core/Header/UserOptions";

export default {
  name: "HomeRouterContainer",
  components: { MainFooter, UserOptions },
  computed: {
    hasNewLeftNavEnabled() {
      return this.$store.getters["auth/isNewLeftNav"];
    },
  },
  mounted() {
    if (document.getElementById("gPlacesScript_1") == null) {
      let googleApiPlaces = `https://maps.googleapis.com/maps/api/js?key=${process.env.GOOGLE_API_KEY}&libraries=places&language=en-US`;
      let tag = document.createElement("script");
      tag.setAttribute("src", googleApiPlaces);
      tag.setAttribute("id", "gPlacesScript_1");
      document.head.appendChild(tag);
    }
  },
};
</script>

<style lang="scss">
.home-container {
  width: 90%;
  margin: auto;

  .home-nav {
    line-height: 45px;
    height: 45px;
    width: 100%;
    top: 0px;
    left: 0px;
    position: fixed;
    background: #fff;
    padding: 10px 50px;
    z-index: 100;
    border-bottom: solid 2px #e4e4e4;

    .home-nav-content {
      display: flex;
      width: 90%;
      justify-content: space-between;
      padding: 0px 20px;

      .inside-sales-button {
        position: absolute;
        right: 370px;
      }

      .user {
        float: right;
        height: 25px;
        line-height: 25px;
      }

      .logo-name {
        float: left;
        font-size: 27px;
        margin-top: 0px;

        img {
          height: 45px;
        }

        a {
          text-decoration: none;
          color: #666;
        }
      }
    }

    .nav-right {
      float: right;
    }

    .nav-left,
    .nav-right {
      @media screen and (max-width: 1280px) {
        float: none;
      }
    }

    .nav-left .title {
      font-size: 24px;
      color: #4c4c4c;
      font-weight: 300;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 40rem;
    }

    .nav-left .title a {
      font-size: 28px;
      color: #4c4c4c;
      font-weight: 300;
    }

    .nav-left .sub-title {
      font-size: 16px;
      color: #999999;
      padding-left: 0px;
    }

    .nav-right ul.nav-form {
      display: inline-block;
      list-style: none;
      margin: 0px;
      padding: 0px;
    }

    .nav-right ul.nav-form li {
      float: left;
      padding: 5px;
      margin-left: 20px;
    }

    .nav-right ul.nav-form li a.nav-action {
      text-decoration: none;
      font-size: 15px;
      color: $--color-curious-blue;
      text-align: center;
      height: 45px;
      line-height: 45px;
    }

    .nav-right ul.nav-form li .nav-search input {
      height: 40px;
      width: 300px;
      line-height: 40px;
      border-radius: 30px;
    }
  }
}
</style>
